import React from 'react';
import { Chip } from '@mui/material';

/**
 * Reusable urgency chip component for tickets
 */
const UrgencyChip = ({ urgency, size = 'small' }) => {
  let color = 'default';

  switch (urgency) {
    case 'LOW':
      color = 'info';
      break;
    case 'MEDIUM':
      color = 'warning';
      break;
    case 'HIGH':
    case 'URGENT':
      color = 'error';
      break;
    default:
      color = 'default';
  }

  return <Chip label={urgency} color={color} size={size} />;
};

export default UrgencyChip;
